export class SessionExpiredHandler {
    public constructor(naja: any) {
        naja.addEventListener('error', (event: {xhr: XMLHttpRequest}) => {
            if (event.xhr.status === 401) {
                try {
                    const data = JSON.parse(event.xhr.responseText);

                    if (data.sessionExpired && data.redirect) {
                        window.location.href = data.redirect;
                    }
                } catch {
                    // Not a JSON response, ignore
                }
            }
        });
    }
}
